import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import {
    sortableContainer,
    sortableElement,
    sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";

const SortableItem = sortableElement((props) => (
    <tr className="ant-table-row" {...props} />
));
const SortableContainer = sortableContainer((props) => <tbody {...props} />);
const DragHandle = sortableHandle(() => (
    <MenuOutlined style={{ cursor: "move", color: "#999" }} />
));

const FormMoveRows = ({ formRows: currentFormRows, onSortOk }) => {
    const [formRows, setFormRows] = useState(currentFormRows);

    useEffect(() => {
        setFormRows(currentFormRows);
    }, [currentFormRows]);

    const handleSortEnd = ({ oldIndex, newIndex }) => {
        //const { dataSource } = this.state;
        if (oldIndex !== newIndex) {
            const newRows = arrayMove(
                [].concat(formRows),
                oldIndex,
                newIndex
            ).filter((el) => !!el);
            setFormRows(newRows);
        }
    };

    const sortOk = () => {
        onSortOk(formRows);
    };

    const DraggableContainer = (props) => (
        <SortableContainer
            useDragHandle
            helperClass="row-dragging"
            lockAxis="y"
            onSortEnd={handleSortEnd}
            {...props}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const index = formRows.findIndex(
            (x) => x.id === restProps["data-row-key"]
        );
        return <SortableItem index={index} {...restProps} />;
    };

    const columns = [
        {
            title: "Sort",
            dataIndex: "sort",
            width: 30,
            className: "drag-visible",
            render: () => <DragHandle />,
        },
        {
            title: "Name",
            dataIndex: "name",
            className: "drag-visible cursorPointer",
        },
    ];

    return (
        <>
            <p>Use handle to drag and arrage rows.</p>
            <Table
                pagination={false}
                dataSource={formRows}
                columns={columns}
                rowKey="id"
                showHeader={false}
                components={{
                    body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow,
                    },
                }}
            />
            <Button type="primary" onClick={sortOk} style={{ marginTop: 16 }}>
                OK
            </Button>
        </>
    );
};

export default FormMoveRows;
